import formsService from '@/services/formsService'
import countries from '@/libs/countries'

const state = {
  formId: '',
  forms: [],
  formSubmits: [],
  loadingForms: true,
  loadingFormSubmits: false,
  paginationForms: {},
  paginationFormSubmits: {},
  totalForms: 0,
  totalFormSubmits: 0,
  selectedForm: {
    email: {},
    phone: {},
    options: {}
  },
  exporting: false,
  search: ''
}

const mutations = {
  'SET_FORM_ID' (state, formId) {
    state.formId = formId
  },
  'SET_TOTAL_FORMS' (state, totalForms) {
    state.totalForms = totalForms
  },
  'SET_TOTAL_FORM_SUBMITS' (state, totalFormSubmits) {
    state.totalFormSubmits = totalFormSubmits
  },
  'SET_FORMS' (state, forms) {
    state.forms = forms
  },
  'SET_FORM_SUBMITS' (state, formSubmits) {
    state.formSubmits = formSubmits
  },
  'SET_SEARCH_FORMS' (state, search) {
    state.search = search
  },
  'SET_LOADING_FORMS' (state, status) {
    state.loadingForms = status
  },
  'SET_LOADING_FORM_SUBMITS' (state, status) {
    state.loadingFormSubmits = status
  },
  'SET_PAGINATION_FORMS' (state, pagination) {
    state.paginationForms = pagination
  },
  'SET_PAGINATION_FORM_SUBMITS' (state, pagination) {
    state.paginationFormSubmits = pagination
  },
  'SET_EXPORTING_FORM' (state, status) {
    state.exporting = status
  },
  'SET_SELECTED_FORM' (state, form) {
    if (!form.options) form.options = { color: '' }

    const country = countries.find(element => {
      return element.number === form.phone.countryCode
    })

    if (country) {
      form.phone = {
        phone: {
          ...country,
          phone: form.phone.number
        },
        message: form.phone.message
      }
    } else {
      form.phone = {
        phone: {
          country: 'Colombia',
          code: 'co',
          number: '57',
          phone: form.phone.number
        },
        message: form.phone.message
      }
    }

    state.selectedForm = form
  }
}

const actions = {
  createForm (vuexContext, data) {
    return new Promise((resolve, reject) => {
      formsService.createForm(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        data)
        .then(() => {
          vuexContext.dispatch('getForms')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  async getForm (vuexContext, formId) {
    const app = vuexContext.getters.appUuid
    const company = vuexContext.getters.companyUuid

    const response = await formsService.getForm(company, app, formId)

    if (response.forms.count > 0) {
      vuexContext.commit('SET_SELECTED_FORM', response.forms.rows[0])
    } else {
      throw new Error('No se encontraron formularios')
    }
  },
  getForms (vuexContext) {
    vuexContext.commit('SET_LOADING_FORMS', true)
    formsService.getForms(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.paginationForms,
      vuexContext.state.search)
      .then(response => {
        vuexContext.commit('SET_TOTAL_FORMS', response.forms.count)
        vuexContext.commit('SET_FORMS', response.forms.rows)
        vuexContext.commit('SET_LOADING_FORMS', false)
      })
      .catch((error) => {
        console.log(error)
        vuexContext.commit('SET_FORMS', [])
        vuexContext.commit('SET_LOADING_FORMS', false)
      })
  },
  getFormSubmits (vuexContext) {
    vuexContext.commit('SET_FORM_SUBMITS', [])
    vuexContext.commit('SET_LOADING_FORM_SUBMITS', true)
    formsService.getFormSubmits(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.selectedForm._id,
      vuexContext.state.paginationFormSubmits,
      vuexContext.state.search)
      .then(response => {
        vuexContext.commit('SET_TOTAL_FORM_SUBMITS', response.submits.count)
        vuexContext.commit('SET_FORM_SUBMITS', response.submits.rows)
        vuexContext.commit('SET_LOADING_FORM_SUBMITS', false)
      })
      .catch((error) => {
        console.log(error)
        vuexContext.commit('SET_FORM_SUBMITS', [])
        vuexContext.commit('SET_LOADING_FORM_SUBMITS', false)
      })
  },
  async updateForm (vuexContext, data) {
    const app = vuexContext.getters.appUuid
    const company = vuexContext.getters.companyUuid

    await formsService.updateForm(company, app, data)
    vuexContext.dispatch('getForms')
  },
  exportFormSubmits (vuexContext) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_EXPORTING_FORM', true)
      formsService.exportFormSubmits(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedForm._id,
        { filename: vuexContext.state.selectedForm.name })
        .then(() => {
          vuexContext.commit('SET_EXPORTING_FORM', false)
          resolve(true)
        }).catch(error => {
          vuexContext.commit('SET_EXPORTING_FORM', false)
          reject(error)
        })
    })
  }
}

const getters = {
  formId (state) {
    return state.formId
  },
  totalForms (state) {
    return state.totalForms
  },
  formCode (state) {
    return state.selectedForm.code
  },
  selectedForm (state) {
    if (state.selectedForm.email.to !== undefined) {
      if (state.selectedForm.email.to['0'] === undefined) {
        state.selectedForm.email.to['0'] = ''
      }
    }
    return state.selectedForm
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
